// @flow

import { createSelector } from 'reselect';
import { filter, find, flow, get, identity, includes, placeholder } from 'lodash/fp';

function getRouteFilter(categories, sportSlug, competitionSlug) {
  if (!sportSlug || !categories[sportSlug]) {
    return identity;
  }

  if (!competitionSlug) {
    const sport = categories[sportSlug];

    return filter(flow(get(sport.filterKey), includes(placeholder, sport.filterValues)));
  }

  const competition = find({ slug: competitionSlug }, categories[sportSlug].subcategories) || {};

  return filter(flow(get(competition.filterKey), includes(placeholder, competition.filterValues)));
}

const routeFilterSelector = createSelector(
  get('sportCategories.items'),
  get('lobbyChallenges.activeSport'),
  get('lobbyChallenges.activeSubCategory'),
  getRouteFilter
);

export default routeFilterSelector;
